import React, { useEffect, useMemo, useState, } from 'react';
import { ActivityIndicator, Dimensions, Image, ImageBackground, Platform, ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native';
import { ButtonSizeDLS, ButtonTypeDLS, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { ModalAlignmentEnum, SCREEN_SIZE, } from '@voltmoney/types';
import BottomSheet from '../BottomSheet';
import { Typography } from '../../typography/Typography';
import { Icon } from '../../icon/Icon';
import { Space } from '../../space/Space';
import { Button } from '../../button/Button';
import { isMobile } from '../../stack/utils';
import { AppBottomNav } from "../../appBottomNav/AppBottomNav";
import { addCommasToNumber, isFromTDLPlatform } from "../utils";
import { PendingUnpledgeView } from "../../PendingUnpledgeView/PendingUnpledgeView";
import TooltipComp from "../TooltipComp";
import { LoanRenewalExpiredDashboardCard } from "../../loanRenewalExpiredDashboardCard/loanRenewalExpiredDashboardCard";
import CustomHeader from "../../customHeader/CustomHeader";
import ButtonDLSBase from '../../button/ButtonDLS.base';
import ThemeProvider from '@voltmoney/theme';
const UnpledgeStatusPage = ({ triggerAction, backAction, modalState, continuePress, totalOutstanding, height, creditLimit, sanctionedAmount, isPendingForeclosure, increaseLimitAction, pendingArray, pendingRequestAction, stepperData, loading, showCamsLoader, showIncreaseLimit, isLoanContractExpired, loanRenewalExpiredDashboardCardProps, showPledgedPortfolio = true, showLeinRemovalTracking, showDecreaseLimit, showBottomNav, goBackAction, platform, showNavNextLoader, }) => {
    const isfromTDL = isFromTDLPlatform();
    const [showModal, setShowModal] = useState(false);
    const [creditValue, setCreditValue] = useState(0);
    const [cardState, setModalState] = useState('Penny');
    const [modalHeight, setModalHeight] = useState(332);
    const [isDismissable, setDismissable] = useState(false);
    const [showToolTip, setShowToolTip] = useState(false);
    const [showIncreaseLimitModal, setShowIncreaseLimitModal] = useState(false);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    useEffect(() => {
        console.warn('REACHED MODAL STATE', modalState);
        if (modalState) {
            if (modalState === 'error') {
                setDismissable(true);
                setModalHeight(244);
            }
            if (modalState === 'success') {
                setModalHeight(228);
            }
            setModalState(modalState);
        }
        else {
            setModalState('Penny');
        }
    }, [modalState]);
    const _headerChild = useMemo(() => {
        return !showBottomNav ? (React.createElement(View, { style: { width: '100%', marginHorizontal: -16, marginRight: -24, paddingHorizontal: -16 } },
            React.createElement(CustomHeader, { title: "Manage limit", hideNeedHelp: true, triggerAction: triggerAction, goBackAction: goBackAction, hideDivider: true }))) : (React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between'
            } },
            React.createElement(View, null,
                React.createElement(Typography, { label: 'Manage limit', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '700', lineHeight: 24 }))));
    }, []);
    const renderInfoBox = () => {
        return (React.createElement(TouchableOpacity, { style: {
                padding: 16,
                zIndex: 1
            }, activeOpacity: 1, onPress: () => {
                setShowToolTip(false);
            } },
            React.createElement(Typography, { fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24, label: "Credit Limit" }),
            React.createElement(View, { style: { marginTop: 24, borderColor: '#E4E7EC', borderWidth: 1, borderRadius: 8, padding: 12 } },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(Typography, { label: 'Credit limit against portfolio', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Typography, { label: '₹' + addCommasToNumber(creditLimit), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: {
                        marginTop: 12,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(View, null,
                        React.createElement(View, { style: { flexDirection: "row" } },
                            React.createElement(Typography, { label: 'Max loan amount sanctioned', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal }),
                            React.createElement(TouchableOpacity, { style: { marginLeft: 4 }, onPress: () => {
                                    setShowToolTip(true);
                                    if (showToolTip) {
                                        setShowToolTip(false);
                                    }
                                } },
                                React.createElement(Icon, { id: 'bt_creditLimit_info', name: IconTokens.Info, size: IconSizeTokens.LG }),
                                showToolTip &&
                                    React.createElement(TooltipComp, { title: "This is the max sanctioned loan amount approved as per your loan agreement, it can be revised by doing another agreement by increasing your limit" })))),
                    React.createElement(Typography, { label: '₹' + addCommasToNumber(sanctionedAmount), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: { height: 1, width: '100%', backgroundColor: "#E4E7EC", marginTop: 16 } }),
                React.createElement(View, { style: {
                        marginTop: 16,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'Credit limit', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Night })),
                    React.createElement(Typography, { label: '₹' + addCommasToNumber(creditLimit), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Secondary_100 }))),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, label: "Got it", fontSize: FontSizeTokens.SM, onPress: () => {
                        setShowModal(false);
                        setShowToolTip(false);
                    } }))));
    };
    const modalContentPresenter = () => {
        return renderInfoBox();
    };
    useEffect(() => {
        setCreditValue(totalOutstanding);
        return () => {
            setModalHeight(332);
            setModalState('Penny');
            setShowModal(false);
        };
    }, []);
    const renderEmptyState = () => {
        return (React.createElement(View, { style: [
                styles.container,
                { height: Platform.OS === "ios" ? height - 24 : height }
            ] },
            React.createElement(View, { style: {
                    flex: 1
                } },
                React.createElement(View, { style: styles.header }, _headerChild),
                React.createElement(View, { style: [{ height: height - 138, justifyContent: 'center', alignItems: 'center' }] },
                    React.createElement(Image, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Empty_Limit.png" }, style: { width: 250, height: 250 } }),
                    React.createElement(View, { style: {
                            alignItems: 'center',
                            alignContent: 'center',
                            justifyContent: 'center',
                            paddingHorizontal: 50
                        } },
                        React.createElement(Typography, { label: 'You can manage your credit limit, and mark or unmark your funds from here after you start your credit limit', color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '500', lineHeight: 20, textAlign: TextAlignTokens.center }))),
                React.createElement(View, { style: styles.footer }, _footerChild()))));
    };
    const renderExpiredFlow = () => {
        const { loanExpiryDay, dueDay, creditLimitAmount, outStandingAmount, scenario, isRepaymentInProgress, showInfoSection, customerSupportAction, renewNowAction, repayAction, reOpenLoanAccountAction, showCta, lenderId, isLoanExpired, refundAction, isPendingLoanRenewal, } = loanRenewalExpiredDashboardCardProps;
        return loanRenewalExpiredDashboardCardProps && (React.createElement(View, { style: {
                marginHorizontal: -16,
                marginBottom: -16
            } },
            React.createElement(LoanRenewalExpiredDashboardCard, { loanExpiryDay: loanExpiryDay, dueDay: dueDay, creditLimitAmount: creditLimitAmount, outStandingAmount: outStandingAmount, showInfoSection: showInfoSection, customerSupportAction: customerSupportAction, renewNowAction: renewNowAction, repayAction: repayAction, reOpenLoanAccountAction: reOpenLoanAccountAction, showCta: showCta, scenario: scenario, triggerAction: triggerAction, isRepaymentInProgress: isRepaymentInProgress, lenderId: lenderId, isLoanExpired: isLoanExpired, refundAction: refundAction, isPendingLoanRenewal: isPendingLoanRenewal })));
    };
    const _bodyChild = () => {
        return (React.createElement(View, { style: { padding: 16 } },
            isLoanContractExpired ? (React.createElement(React.Fragment, null, renderExpiredFlow())) : (React.createElement(React.Fragment, null,
                React.createElement(ImageBackground, { source: {
                        uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/background_purple.png',
                    }, imageStyle: { borderRadius: 16 }, style: styles.groupLayout },
                    React.createElement(View, { style: {
                            padding: 16,
                            flexDirection: 'row',
                        } },
                        React.createElement(Image, { source: {
                                uri: isfromTDL ?
                                    'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Personal+Loan_FS.png' :
                                    'https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/rupee_new_1.png',
                            }, style: { width: 56, height: 56 } }),
                        React.createElement(View, { style: { marginLeft: 9 } },
                            React.createElement(Typography, { label: 'Existing credit limit', color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '500', lineHeight: 20 }),
                            React.createElement(View, { style: styles.plainRow },
                                React.createElement(Typography, { label: '₹' + addCommasToNumber(creditLimit), color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.XXXXL, fontFamily: FontFamilyTokens.Inter, fontWeight: '700', lineHeight: 40 }),
                                React.createElement(TouchableOpacity, { onPress: () => {
                                        setShowModal(true);
                                    }, style: { marginLeft: 5 } },
                                    React.createElement(Icon, { id: 'bt_manageLimit_info', name: IconTokens.Info, size: IconSizeTokens.XL, color: ColorTokens.Grey_Night })))))),
                React.createElement(View, { style: { marginTop: 12 } },
                    React.createElement(Button, { id: 'bt_manageLimit_increaseLimit', width: ButtonWidthTypeToken.FULL, label: 'Increase limit', type: ButtonTypeTokens.LargeFilled, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, loading: loading, onPress: () => {
                            if (showIncreaseLimit) {
                                if (increaseLimitAction) {
                                    triggerAction(increaseLimitAction);
                                }
                            }
                            else {
                                setShowIncreaseLimitModal(true);
                            }
                        } })))),
            pendingArray.length !== 0 ?
                React.createElement(View, { style: { marginTop: 12 } },
                    React.createElement(PendingUnpledgeView, { color: ColorTokens.Grey_Charcoal, isList: true, actionList: pendingArray, viewAction: pendingRequestAction, triggerAction: triggerAction }))
                : React.createElement(View, { style: styles.portfoilioDividerStyle }),
            showPledgedPortfolio &&
                React.createElement(View, { style: { marginTop: 24 } },
                    React.createElement(Typography, { label: 'Pledged portfolio', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24 }),
                    React.createElement(View, { style: Platform.OS === 'ios' ? [
                            styles.frameGroup,
                            {
                                marginTop: 16,
                                borderRadius: 8,
                                padding: 16,
                                borderWidth: 1,
                                borderColor: '#E4E7EC',
                            }
                        ] : [
                            {
                                marginTop: 16,
                                borderRadius: 8,
                                padding: 16,
                                borderWidth: 1,
                                borderColor: '#E4E7EC',
                                shadowColor: 'black'
                            },
                        ] },
                        React.createElement(View, { style: { flexDirection: 'row' } },
                            React.createElement(Image, { source: {
                                    uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/image+1997.png',
                                }, style: { width: 26, height: 26 } }),
                            React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                            React.createElement(Typography, { label: 'Mutual funds', fontWeight: '600', fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24 })),
                        React.createElement(View, { style: {
                                marginTop: 16,
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                paddingTop: 2,
                            } },
                            React.createElement(Typography, { label: 'Portfolio value', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Night }),
                            React.createElement(Typography, { label: '₹' + addCommasToNumber(creditValue), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Night })),
                        React.createElement(View, { style: {
                                height: 1,
                                backgroundColor: '#E4E7EC',
                                marginTop: 16,
                                marginHorizontal: -16
                            } }),
                        React.createElement(View, { nativeID: 'txt_manageLimit_viewDetails' },
                            React.createElement(TouchableOpacity, { activeOpacity: 1, onPress: () => {
                                    if (backAction) {
                                        triggerAction({
                                            ...backAction
                                        });
                                    }
                                }, style: {
                                    marginTop: 13,
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    alignContent: 'center',
                                    ...showLeinRemovalTracking && {
                                        justifyContent: 'flex-end'
                                    }
                                } },
                                React.createElement(Typography, { label: 'View details', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', color: ColorTokens.Primary_100, lineHeight: 20 }),
                                React.createElement(View, { style: { marginTop: 2 } }, showNavNextLoader ? (React.createElement(ActivityIndicator, { color: theme.colors[ColorTokens.Primary_100], style: { left: 4 }, size: 16 })) :
                                    React.createElement(Icon, { name: IconTokens.CHEVRON_BLUE_RIGHT, color: ColorTokens.Primary_100 }))))))));
    };
    const _footerChild = () => {
        return (React.createElement(View, { style: {
                width: '100%',
            } },
            React.createElement(AppBottomNav, { currentRoute: 'MANAGE_LIMIT', navigationAction: continuePress, triggerAction: triggerAction })));
    };
    const renderAccountOpeningModal = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_DLS, size: IconSizeTokens.XXXXXXL })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Account set up in-progress" })),
            React.createElement(View, { style: { padding: 16, backgroundColor: '#F1F3F5', borderRadius: 8, marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: "You\u2019ll be able to increase limit as soon as the account set up is complete. Please try again after sometime", color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.left })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Got it', onPress: () => setShowIncreaseLimitModal(false), isDisabled: false }))));
    };
    const renderMainBody = () => {
        return (React.createElement(View, { style: [
                styles.container,
                { height: Platform.OS === "ios" ? height - 14 : height }
            ] },
            React.createElement(View, { style: {
                    flex: 1
                } },
                React.createElement(View, { style: styles.header }, _headerChild),
                React.createElement(ScrollView, { style: [{ height: height - 138, paddingBottom: 100 }] }, _bodyChild()),
                React.createElement(View, { style: styles.footer }, (!showModal && showBottomNav && platform !== 'REDVISION') && _footerChild())),
            showModal &&
                React.createElement(View, { style: {
                        bottom: 0,
                        position: 'absolute',
                        zIndex: 1
                    } },
                    React.createElement(BottomSheet, { id: "bt_creditLimit_cancel", autoAdjustHeight: false, height: 276, width: '100%', closeFunction: () => {
                            setShowModal(false);
                            setShowToolTip(false);
                        }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 504, routeId: "routeId", handleKeyboard: true }, modalContentPresenter())),
            showIncreaseLimitModal &&
                React.createElement(View, { style: {
                        bottom: 0,
                        position: 'absolute',
                        zIndex: 1
                    } },
                    React.createElement(BottomSheet, { id: "bt_creditLimit_cancel", autoAdjustHeight: false, height: isMobile(getScreenType(Dimensions.get('window').width)) && Platform.OS !== 'web' ? Platform.OS === 'android' ? 350 : 290 : 276, width: '100%', closeFunction: () => {
                            setShowModal(false);
                            setShowToolTip(false);
                            setShowIncreaseLimitModal(false);
                        }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 504, routeId: "routeId", handleKeyboard: true }, renderAccountOpeningModal()))));
    };
    return isPendingForeclosure ? renderEmptyState() : renderMainBody();
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height - 114,
        marginHorizontal: -16,
    },
    blankContainer: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height,
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    backdrop: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdropText: {
        color: 'white',
        fontSize: 16,
    },
    contentContainer: {
        padding: 16,
        flex: 1, // pushes the footer to the end of the screen
    },
    card: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        height: '50%',
        padding: 20,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    cardText: {
        fontSize: 18,
    },
    groupContainer: {
        zIndex: 0,
    },
    groupLayout: {
        height: 88,
        width: '100%',
        borderRadius: 16,
    },
    boldText: {
        fontWeight: 'bold',
        color: '#1D2939',
        fontSize: 14,
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        zIndex: 99,
        width: '100%',
        borderWidth: 1,
        borderColor: '#F1F3F5',
        backgroundColor: 'rgb(255, 255, 255)',
        shadowColor: 'rgba(0, 0, 0, 0.2)',
        shadowOffset: {
            width: 0,
            height: -1,
        },
        shadowOpacity: 0.5,
    },
    frameGroup: {
        borderRadius: 8,
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowRadius: 8,
        elevation: 8,
        borderColor: '#E4E7EC',
        marginTop: 16,
        borderStyle: 'solid',
        shadowOpacity: 1,
        shadowOffset: {
            width: 0,
            height: 2,
        },
    },
    tooltip: {
        position: 'absolute',
        backgroundColor: '#667085',
        color: 'white',
        padding: 16,
        borderRadius: 5,
        width: 272,
        bottom: '100%',
        left: '50%',
        transform: [{ translateX: -150 }],
    },
    plainRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    portfoilioDividerStyle: {
        height: 1,
        backgroundColor: '#E4E7EC',
        marginTop: 24,
    },
    header: {
        paddingHorizontal: 16,
        paddingTop: 12,
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F3F5',
        backgroundColor: '#FFF',
        height: 66,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: Platform.OS === "ios" ? 24 : 0
    },
});
export default UnpledgeStatusPage;
